import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import HandbookChapter from './HandbookChapter.vue';
let HandbookCustomizationOptions = class HandbookCustomizationOptions extends Vue {
};
HandbookCustomizationOptions = __decorate([
    Component({
        components: {
            HandbookChapter
        }
    })
], HandbookCustomizationOptions);
export default HandbookCustomizationOptions;
